Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
  value: function value(r) {
    if (null == this) throw new TypeError('"this" is null or not defined');
    var e = Object(this),
        t = e.length >>> 0;
    if ("function" != typeof r) throw new TypeError("predicate must be a function");

    for (var n = arguments[1], o = 0; o < t;) {
      var i = e[o];
      if (r.call(n, i, o, e)) return o;
      o++;
    }

    return -1;
  }
});